<template>
  <div>
    <el-form-item label="" >
      <div v-for="modelType in modelTypeList" style="width: 100%; min-height: 100px;border:  1px solid rgba(215, 215, 215, 1); margin-top: 15px">
    <div style="width: 100%; height: 40px; line-height: 40px; background: rgba(242, 242, 242, 1)">
      <el-form-item label="型号分类:" :rules="[{ required: true, message: '请输入型号分类', trigger: 'blur' }]" >
        <el-input v-model="modelType.specName" placeholder="型号分类"   size="small" style="width: 35%"
                  @keyup.enter.native="handleModelTypeInputConfirm(modelType)"
                  @blur="handleModelTypeInputConfirm(modelType)"
        ></el-input>
        <el-input v-model="modelType.specNameEn" placeholder="英文型号分类" size="small" style="width: 35%; margin-left: 15px;"
        ></el-input>
        <el-button @click="deleteModelType(modelType)" type="text" size="small" style="float: right; margin-right: 10px">删除</el-button>
      </el-form-item>
    </div>
    <div v-if="modelType.specName">
      <el-form-item label="型号:" >
        <draggable filter=".undraggable" @update="sortDynamicTags($event,modelType)" style="display: inline" >
          <el-tag
              :key="tag.key"
              v-for="tag in modelType.specOptionVoList"
              closable
              :disable-transitions="false"
              @close="handleTagClose(tag, modelType.specOptionVoList)">
            {{tag.specOptionName}}<span v-if="tag.specOptionNameEn">({{tag.specOptionNameEn}})</span>
          </el-tag>
          <el-popover
              v-model="modelType.inputVisible"
              width="500"
              trigger="click"
             >
            <el-input v-model="modelType.inputValue" placeholder="型号名称" size="small" style="width: 35%; margin-left: 15px;"></el-input>
            <el-input v-model="modelType.inputValue2" placeholder="英文型号名称" size="small" style="width: 35%; margin-left: 15px; margin-right: 15px"></el-input>
            <el-button type="success" size="small" plain @click="handleInputConfirm(modelType)">
              确认
            </el-button>
          </el-popover>
        </draggable>
        <el-button class="button-new-tag undraggable" size="small"  @click="showInput(modelType)">添加商品型号</el-button>
      </el-form-item>
    </div>
  </div>
  
      <el-button class="button-new-tag" size="small" @click="addModelTypeList" style="margin-left: 0">+添加型号分类</el-button>
    </el-form-item>
    <el-form-item label="价格" v-if="modelTypeListData.length != 0">
      <el-table
          :data="modelTypeListData"
          :span-method="objectSpanMethod"
          max-height="500"
          border
          >
        <el-table-column
            v-for="col in modelTypeList"
            :prop="col.specName"
            :label="col.specName"
            v-if="col.specName"
            fixed="left"
            min-width="150"
            align="center">
        </el-table-column>
        <el-table-column
            prop="preferentialPrice"
            label="优惠价"
            width="180"
            align="center"
            >
  
          <template slot="header" slot-scope="scope">
            <span>优惠价</span><br>
            <el-input v-model="value1"
                      size="small"
                      @input="validateNumber(value1,(data)=>{value1 = data})"
                      placeholder='请输入优惠价'
                      style="width: 80%"
                      @change="inputBlur1">
            </el-input>
          </template>
          
          <template slot-scope="{row,$index}">
            <el-input v-model="row.preferentialPrice" @change="resetPrice1" placeholder="优惠价" size="small" style="width: 80%"
                      @input="validateNumber(row.preferentialPrice,(data)=>{row.preferentialPrice = data})"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
            prop="price"
            label="原价"
            width="180"
            align="center"
            >
          <template slot="header" slot-scope="scope">
            <span><font color="#F56C6C">*</font>原价</span><br>
            <el-input v-model="value2"
                       size="small"
                        @input="validateNumber(value2,(data)=>{value2 = data})"
                       placeholder='请输入原价'
                       style="width: 80%"
                       @change="inputBlur2">
            </el-input>
          </template>
          <template slot-scope="{row,$index}">
            <el-input v-model="row.price" @change="resetPrice2" placeholder="原价" size="small" style="width: 80%"
                      @input="validateNumber(row.price,(data)=>{row.price = data})"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
    </el-form-item>
  </div>
</template>
<script>
  import draggable from 'vuedraggable';
  export default {
    name: 'commodityModel',
    components: {draggable},
    props: {
      modelTypeListDataMain: {
        type: Array,
        default: []
      },
      modelTypeListMain: {
        type: Array
      },
      skuPriceVoListTemp: {
        type: Array
      },
    },
    data() {
      return {
        typeTagShow: false,
        modelTypeListData: [],
        modelTypeList: [],
        spanArr: {},
        position: 0,
        percent: 0,
        value1: '',
        value2: '',
        rules: {
          specName: [
            {required: true, message: '请输入分类名称', trigger: 'blur'},
          ],
        },
      };
      
    },
    methods: {
      handleClose(){
        this.typeTagShow = false;
      },
      validateNumber(value,collback) {
        value = value.replace(/[^\d.]/g,""); // 清除"数字"和"."以外的字符
        value = value.replace(/^\./g,""); // 验证第一个字符是数字
        value = value.replace(/\.{2,}/g,"."); // 只保留第一个, 清除多余的
        value = value.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
        // 保存n个小数
        value = value.replace(/^(\-)*(\d+)\.(\d{2}).*$/,'$1$2.$3');         // 只能输入n个小数
        if(value.indexOf(".") < 0 && value !=""){
          value = parseFloat(value);
          value = (value+"").substr(0,6);
        } else {
          let value1 = value.substr(0,value.indexOf(".")).substr(0,6);
          let value2 = value.substr(value.indexOf("."));
          value = value1+value2;
        }
        value = isNaN(value) ? 0 : value; // 不让显示NAN

        collback(value);
      },
      conformPrice() {
        let skuPriceVoList = [];
        for(let data of this.modelTypeListData) {
          let skuPriceVo = {};
          let fieldTemp = {};
          const fields =  Object.keys(data);
          for(let field of fields) {
            if(field.indexOf('rice') == -1) {
              fieldTemp[field] = data[field];
            }
          }
          let jsonData = JSON.stringify(fieldTemp);
          skuPriceVo.attributeName = jsonData;
          skuPriceVo.price = data.price;
          skuPriceVo.preferentialPrice = data.preferentialPrice;
          skuPriceVoList.push(skuPriceVo);
        }

      },
      resetPrice1() {
        this.value1 = '';
      },
      resetPrice2() {
        this.value2 = '';
      },

      inputBlur1() {
        for(const data of this.modelTypeListData) {
          data.preferentialPrice = this.value1;
        }
      },
      inputBlur2() {
        for(const data of this.modelTypeListData) {
          data.price = this.value2;
        }
      },
      sortDynamicTags(evt,modelType) {
        let oldValue = modelType.specOptionVoList[a.oldIndex];
        modelType.specOptionVoList.splice(evt.oldIndex,1);
        modelType.specOptionVoList.splice(evt.newIndex,0,oldValue);
        this.changeModelTypeListData();
      },

      rowspan() {
        this.spanArr = {a:1};
        this.position = {a:1};
        let that = this;
        this.modelTypeListData.forEach((item,index) => {

          const fields =  Object.keys(item);
          if(index === 0) {
            fields.forEach((field) => {
              if(field.indexOf('rice') == -1) {
                that.spanArr[field] = [1];
                that.position[field] = 0;
              }
            });

          } else {
            fields.forEach((field) => {
              if(field.indexOf('rice') == -1) {
                if(that.modelTypeListData[index][field] === that.modelTypeListData[index-1][field] ){
                  that.spanArr[field][this.position[field]] += 1;
                  that.spanArr[field].push(0);
                }else{
                  that.spanArr[field].push(1);
                  that.position[field] = index;
                }
              }
            });
          }

        });
        this.$emit('changeSpanArr', this.spanArr);
      },

      objectSpanMethod(item) {
        let row = item.row;
        let column = item.column;
        let field = column.property;
        let rowIndex = item.rowIndex;
        let columnIndex = item.columnIndex;
        if(this.spanArr[field]) {
          const _row = this.spanArr[field][rowIndex];
          return {
            rowspan: _row,
            colspan: 1
          };
        }

      },

      makeupTable(columns,fieldName) {
        let modelTypeListDataTemp = [];
        if(this.modelTypeListData.length == 0) {
          for(const column of columns) {
            const d = {
              preferentialPrice: '',
              price: ''
            };
            d[fieldName] = column.specOptionName;
            modelTypeListDataTemp.push(d);
          }
        } else {
          for(const data of this.modelTypeListData) {
            for(const column of columns) {
              const d = JSON.parse(JSON.stringify(data));
              d[fieldName] = column.specOptionName;
              modelTypeListDataTemp.push(d);
            }
          }
        }

        this.modelTypeListData = modelTypeListDataTemp;
      },

      changeModelTypeListData() {
        this.modelTypeListData = [];
        if(this.modelTypeList.length == 0) {
          this.value1 = '';
          this.value2 = '';
          return;
        }
        for(const modelType of this.modelTypeList) {
          if(modelType.specOptionVoList.length > 0) {
            this.makeupTable(modelType.specOptionVoList, modelType.specName);
          }
        }
        if(this.modelTypeListData.length == 0) {
          this.value1 = '';
          this.value2 = '';

        }

        for(let m of this.modelTypeListData) {
          let newValFieldTemp = {};
          const fields =  Object.keys(m);
          for(let field of fields) {
            if(field.indexOf('rice') == -1) {
              newValFieldTemp[field] = m[field];
            }
          }
          let s = JSON.stringify(newValFieldTemp);
          for(let modelTypeListData of this.skuPriceVoListTemp) {
            if(modelTypeListData.attributeName == s) {
              this.$set(m,"price", modelTypeListData.price);
              this.$set(m,"skuId", modelTypeListData.skuId);
              this.$set(m,"preferentialPrice", modelTypeListData.preferentialPrice);
            }
          }
        }
        
        this.rowspan();
        this.handleModelTypeListDataChange();
      },
      
      
      initModelTypeData() {

        this.modelTypeListData = [];
        if(this.modelTypeListMain.length == 0) {
          return;
        }
        for(const modelType of this.modelTypeListMain) {
          this.makeupTable(modelType.specOptionVoList, modelType.specName);
        }
        
        for(let m of this.modelTypeListData) {
          let newValFieldTemp = {};
          const fields =  Object.keys(m);
          for(let field of fields) {
            if(field.indexOf('rice') == -1) {
              newValFieldTemp[field] = m[field];
            }
          }
          let s = JSON.stringify(newValFieldTemp);
          for(let modelTypeListData of this.skuPriceVoListTemp) {
            if(modelTypeListData.attributeName == s) {
              this.$set(m,"price", modelTypeListData.price);
              this.$set(m,"skuId", modelTypeListData.skuId);
              this.$set(m,"preferentialPrice", modelTypeListData.preferentialPrice);
            }
          }
        }
        this.rowspan();
      },
      
      addModelTypeList() {
        if(this.modelTypeList.length >=3) {
          this.$message({
            type: 'info',
            message: '最多添加三种型号分类！'
          });
          return;
        }
        const date = Date.now();
        let  modelType = {
          id: date,
          field: 'field'+date,
          specName: '',
          specNameEn: '',
          specOptionVoList: [],
          inputVisible: false,
          inputValue: "",
          inputValue2: '',
          ref: ''
        };
       
        this.modelTypeList.push(modelType);
        this.handleModelTypeListChange();
      },
      deleteModelTypeList() {

      },
      handleTagClick(tag) {
        console.log(tag);
      },
      showInput(modelType) {
        if(modelType.specOptionVoList.length >= 10) {
          this.$message({
            type: 'info',
            message: '最多添加十个型号！'
          });
          return;
        }
        modelType.inputVisible = true;
        this.typeTagShow = true;
        // this.$nextTick(_ => {
        //   this.$refs.saveTagInput[0].$refs.input.focus();
        // });
      },
      updateView(e) {
      
      },
      handleInputConfirm(modelType) {
        let inputValue = modelType.inputValue;
        let inputValue2 = modelType.inputValue2;
        
        for(let specOption of modelType.specOptionVoList) {
          if(specOption.specOptionName == inputValue) {
            this.$message({
              type: 'info',
              message: '型号重复！'
            });
            return
          }
          if(specOption.specOptionNameEn == inputValue2) {
            this.$message({
              type: 'info',
              message: '英文型号重复！'
            });
            return
          }
        }
        
        let data;
        if (inputValue) {
          data = {
            key: Date.now(),
            specOptionName: inputValue,
            specOptionNameEn: inputValue2
          };
          modelType.specOptionVoList.push(data);
        }
        modelType.inputVisible = false;
        modelType.inputValue = '';
        modelType.inputValue2 = '';
        this.changeModelTypeListData();
      },
      handleModelTypeInputConfirm(modelType) {
        for(const data of this.modelTypeListData) {
          if(modelType.id == data.id) {
            data.specName = modelType.specName;
          }
        }
        this.handleModelTypeListDataChange();
      },

      handleTagClose(tag, dynamicTags) {
        dynamicTags.splice(dynamicTags.indexOf(tag), 1);
        this.changeModelTypeListData();
      },
      deleteModelType(modelType) {
        const index = this.modelTypeList.indexOf(modelType);
        this.modelTypeList.splice(index,1);
        this.changeModelTypeListData();
      },

      handleModelTypeListDataChange() {
        this.$emit('changeModelTypeListData', this.modelTypeListData);
      },

      handleModelTypeListChange() {
        this.$emit('changeModelTypeList', this.modelTypeList);
      }

    },

    watch: {
      modelTypeListMain: function(newVal,oldVal) {
        this.changeModelTypeListData();
      },
      modelTypeListData:  {
        handler: function(newV,oldV) {
          this.$emit('changeModelTypeListData', this.modelTypeListData);
        },
        deep: true
        
  //
    },
  },

  created: function() {
    this.modelTypeList = this.modelTypeListMain;
    for(let modelType of this.modelTypeList) {
      this.$set(modelType, "inputValue" , "");
      this.$set(modelType, "inputVisible" , false);
    }
    this.initModelTypeData();
  }
  };
</script>


<style scoped>
  .el-tag {
    margin-right: 5px;
  }
</style>
